import { useEffect, useRef } from "react";
import { localGetData, localStoreData } from "../utils/utils";

export const useServerEndpointCleanup = ({
  apiHost,
  cookies,
  removeCookie,
  indexedDb,
  setUser,
}) => {
  const handled = useRef(false);
  const lastServer = localGetData("last_mp_server");

  useEffect(() => {
    if (!lastServer || lastServer === apiHost) {
      localStoreData(apiHost, "last_mp_server");
      return;
    }
    if (handled.current) return;
    handled.current = true;
    if (!window.confirm(
      "It appears that you are connecting to a new server. Please click OK to clear your previously stored data to avoid conflicts with the new server.",
    )) return;

    console.info("Clearing local login after an API endpoint change.");
    Object.keys(cookies).forEach(key => removeCookie(key));
    localStorage.clear();
    localStoreData(apiHost, "last_mp_server");
    indexedDb.delete()
      .catch(() => {
        console.info("Could not delete the local cache after an API endpoint change.");
      })
      .finally(() => {
        // PrivateRoute redirects to /mp after the cache is cleared.
        setUser(null);
      });
  }, [apiHost, lastServer, cookies, removeCookie, indexedDb, setUser]);
};
